import actions from './actions';

const initState = {
    documents: [],
    documentDetail: {},
    loading: false,
    totalItems: 0,
};

export default function documentReducer(state = initState, action) {
    switch (action.type) {

        //#region CRUD
        case actions.GET_DOCUMENTS:
            return { ...state, loading: true, totalItems: 0 };
        case actions.GET_DOCUMENTS_SUCCESS: {
            let { data, totalItems } = action.payload;
            let res = data ? data : [];
            return { ...state, documents: res, totalItems: totalItems, loading: false };
        }
        case actions.GET_DOCUMENTS_ERROR:
            return { ...state, loading: false };

        case actions.GET_DOCUMENT_DETAIL:
            return { ...state, loading: true };
        case actions.GET_DOCUMENT_DETAIL_SUCCESS: {
            let { data } = action.payload;
            let res = data ? data : {};
            return { ...state, documentDetail: res, loading: false };
        }
        case actions.GET_DOCUMENT_DETAIL_ERROR:
            return { ...state, loading: false };
        //#endregion

        default:
            return state;

    }
}
